/**
 * Person detail component created by karora on 24/06/17.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { AppComponent } from '../app.component';
import { ProfileService } from '../services/profile.service';
import { VoxPopService } from '../services/voxpop.service';
import { Person } from '../types/person';


@Component({
  moduleId: module.id,
  selector: 'person-detail',
  templateUrl: './person-detail.component.html',
  styleUrls: ['./person-detail.component.css'],
  providers: [VoxPopService],
})

export class PersonDetailComponent implements OnInit {
  CanAdminister = ProfileService.CanAdminister;
  person: Person;
  errorMessage: string;
  personTypes = [
    // { "person_type_id": 0, "person_type_description": "Invalid" },
    { "person_type_id": 1, "person_type_description": "Public" },
    { "person_type_id": 2, "person_type_description": "Reporter" }
  ];
  editable = false;

  constructor(
    private voxPopService: VoxPopService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    if (!ProfileService.IsLoggedIn()) return;

    console.log("Getting person detail.");
    this.route.params
      .switchMap((params: Params) => this.voxPopService.getPerson(+params['personid']))
      .subscribe(
        person => this.setPerson(person),
        error => this.errorMessage = <any>error,
      );
  }

  setPerson(person: Person) {
    console.log("Loaded person " + person.name + "(" + person.id + ")");
    this.person = person;
    AppComponent.SetTitle(person.name + ' (' + person.id + ')')
  }

  setEditing() {
    this.editable = true;
    console.log("Editable.");
  }

  cancelChanges() {
    this.editable = false;
    console.log("Cancel.");
  }

  saveChanges() {
    console.log("Saving changes.");
    this.voxPopService.updatePerson(this.person);
    this.editable = false;
  }

  personTypeDescription(p: Person): string {
    switch (p.person_type_id) {
      case 2: return "Reporter"; break;
      default: return "Public"; break;
    }
    return p.person_type_description;
  }
}
